//@flow
import React from 'react';
import {
  Box,
  LinearProgress,
  LinearProgressProps,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    height: 16,
    borderRadius: '8px',
    backgroundColor: colors.lightPurple,
  },
  bar: {
    borderRadius: '8px',
  },
  label: {
    color: colors.grey600,
    fontWeight: 500,
    fontSize: '0.875rem',
  },
  rateCompleted: {
    color: '#3A3A49',
    fontWeight: 700,
    fontSize: '14px',
  },
}));

type Props = LinearProgressProps & {
  rateCompleted?: string,
};

export function ProgressBar(props: Props) {
  const classes = useStyles();
  const {rateCompleted, ...otherProps} = props;
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box width="100%">
        <LinearProgress
          classes={{root: classes.root, bar: classes.bar}}
          variant="determinate"
          {...otherProps}
        />
      </Box>
      {rateCompleted && (
        <Box minWidth={35} ml={2}>
          {/* <Typography className={classes.label}>{`${Math.round(
          props.value
        )}%`}</Typography> */}
          <Typography className={classes.rateCompleted}>
            {rateCompleted}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

ProgressBar.propTypes = {
  value: PropTypes.number,
  rateCompleted: PropTypes.string,
};
